import { Box, Switch, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ChangeEventHandler, ReactNode } from 'react'

interface IProps {
  checked?: boolean
  handleChange?: ChangeEventHandler<HTMLInputElement>
  name: string
  label: string | JSX.Element
  disabled?: boolean
  adittionalText?: ReactNode
}

export const SettingsSwitchSimple = ({
  checked,
  handleChange,
  name,
  label,
  disabled,
  adittionalText,
}: IProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',

        alignItems: 'center',
        justifyContent: 'start',
        gap: '8px',
        pl: isMobile ? '15px' : '50px',
      }}
    >
      <Box>
        <Typography fontSize={'14px'}>{label}</Typography>
      </Box>
      {adittionalText && adittionalText}
      <Switch checked={checked} onChange={handleChange} id={name} name={name} disabled={disabled} />
    </Box>
  )
}
